import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  makeStyles,
  TextField,
  Button as ButtonM,
} from '@material-ui/core';
import { KeyboardArrowDownOutlined } from '@material-ui/icons';

import { Button, ButtonTypes } from 'app/components/Material/Inputs/Button';
import { Menu } from 'app/components/Material/Menu';

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    minWidth: '640px',
    boxShadow: '0px 2px 4px rgb(0 0 0 / 20%), 0px 0px 20px rgb(0 0 0 / 15%)',
    borderRadius: '12px',
    [theme.breakpoints.down('xs')]: {
      minWidth: 'unset',
      width: '100%',
      margin: 0,
      marginTop: 'auto',
    },
  },
  modalContent: {
    padding: '24px 24px 22px !important',
  },
  header: {
    paddingBottom: '24px',
  },
  headerLabel: {
    paddingBottom: '8px',
    color: 'var(--text, #333)',
    fontFamily: 'Manrope',
    fontSize: '20px',
    fontStyle: 'normal',
    fontWeight: 800,
    lineHeight: '24px',
  },
  headerSummary: {
    color: 'var(--text, #333)',
    fontFamily: 'Manrope',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '24px',
  },
  roleButton: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    whiteSpace: 'nowrap',
    height: '44px',
    padding: '14px 12px',
    fontWeight: '600',
    fontSize: '14px',
    border: '1px solid rgba(46, 49, 94, 0.16)',
    borderRadius: '8px',
    textTransform: 'none',
    color: '#666666',
    lineHeight: '20px',
    '&:hover': {
      color: '#222222',
      background: 'rgba(86, 94, 237, 0.12)',
    },
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    paddingBottom: '10px',
  },
  emailForm: {
    width: 'calc(100% - 143px)',
    '& .MuiInput-root': {
      '& > input': {
        height: '14px',
      },
    },
  },
  roleForm: {
    width: '30%',
  },
  footer: {
    display: 'flex',
    justifyContent: 'end',
    gap: '8px',
  },
  roleItem: {
    padding: '8px 16px',
    cursor: 'pointer',

    '&:hover': {
      background: 'var(--hover, rgba(86, 94, 237, 0.08))',
    },
  },
  roleLabel: {
    color: 'var(--text, #333)',
    fontFamily: 'Manrope',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '20px',
    paddingBottom: '4px',
  },
  roleContent: {
    color: '#999',
    fontFamily: 'Manrope',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '18px',
  },
  menuRoleModal: {
    '& .MuiPaper-root': {
      maxWidth: '280px',
      [theme.breakpoints.down('xs')]: {
        marginTop: '50px',
      },
    },
  },
}));

export const InviteModal = (props) => {
  const classes = useStyles();

  const {
    show,
    handleClose,
    email,
    onChangeEmail,
    handleInvite,
    role,
    onChangeRole,
    roleMenu,
  } = props;

  const [anchorEl, setAnchorEl] = useState();

  const handleOpenRole = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseRole = () => {
    setAnchorEl();
  };

  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      );
  };

  return (
    <>
      <Dialog
        open={show}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        classes={{ paper: classes.dialogPaper }}
      >
        <DialogContent classes={{ root: classes.modalContent }}>
          <div className={classes.header}>
            <div className={classes.headerLabel}>Invite team members</div>
            <div className={classes.headerSummary}>
              Please enter users email
            </div>
          </div>
          <div className={classes.content}>
            <div className={classes.emailForm}>
              <div className="form-group">
                <div className="label">Email</div>
                <TextField
                  margin="normal"
                  className="kt-width-full custom-form-label"
                  onChange={onChangeEmail}
                  value={email}
                  placeholder="joe@example.com"
                  type="email"
                />
              </div>
            </div>
            <div className={classes.roleForm}>
              <div className="form-group">
                <div className="label">Role</div>
                <ButtonM
                  className={classes.roleButton}
                  onClick={handleOpenRole}
                  style={
                    anchorEl
                      ? {
                          background: 'rgba(46, 49, 94, 0.08)',
                          color: '#222222',
                        }
                      : {}
                  }
                >
                  {role.label}
                  <KeyboardArrowDownOutlined />
                </ButtonM>
              </div>
            </div>
          </div>
          <div className={classes.footer}>
            <Button onClick={handleClose} type={ButtonTypes.ghost}>
              Cancel
            </Button>
            <Button
              disabled={!validateEmail(email)}
              onClick={handleInvite}
              type={ButtonTypes.secondary}
            >
              Invite
            </Button>
          </div>
        </DialogContent>
      </Dialog>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        width={228}
        onClose={handleCloseRole}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        className={classes.menuRoleModal}
        withMobileView={true}
      >
        {roleMenu.map((item, index) => (
          <div
            key={index}
            className={classes.roleItem}
            onClick={() => {
              onChangeRole(item);
              handleCloseRole();
            }}
          >
            <div className={classes.roleLabel}>{item.label}</div>
            <div className={classes.roleContent}>{item.content}</div>
          </div>
        ))}
      </Menu>
    </>
  );
};
